module.exports = "/static/assets/ae21bd02fff4276409bea90e620da158.png";